<template>
  <ion-button
    :color="color"
    :expand="expand"
    :shape="shape"
    :disabled="disabled || loading"
    :fill="fill"
    :router-link="type === 'internal' && link ? link : undefined"
    :router-direction="type === 'internal' ? 'forward' : undefined"
  >
    <ion-icon v-if="icon" slot="start" :icon="ionicons[icon]" ></ion-icon>
    {{ label }}
    <ion-spinner v-if="loading" slot="end" name="circular"></ion-spinner>
  </ion-button>
</template>

<script setup lang="ts">
import { IonButton, IonSpinner, IonIcon } from '@ionic/vue';
import * as ionicons from 'ionicons/icons';

type IonIconType = keyof typeof ionicons;

withDefaults(defineProps<{
  label: string;
  color?: 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger' | 'light' | 'medium' | 'dark';
  type?: 'internal' | 'external';
  expand?: 'full' | 'block';
  shape?: 'round';
  fill?: 'clear' | 'outline' | 'solid';
  disabled?: boolean;
  loading?: boolean;
  link?: string;
  icon?: IonIconType;
}>(), {
  color: 'primary',
  expand: 'block',
  fill: 'solid',
});
</script>
<style scoped>
  ion-spinner {
    @apply ml-16 h-16 w-16 absolute right-16;
  }

  ion-button {
    @apply mx-0 mb-0;
    --border-radius: 8px;
  }
</style>
